<template>
    <div class="racing-tool-back" @click="racingToolClicked(itemData)">
        <div class="racing-tool-leftimg"
        :class="this.hasPerms(itemData.flag) === true ? ('coloricon' + itemData.menuTag) : 'card-backgroundgray'"
        >
            <i class="icon iconfont" :class="itemData.icon"></i>
        </div>
        <div class="racing-tool-right">
            <div>{{ itemData.rightTitle }}</div>
            <div class="racing-tool-desc">{{ itemData.rightDesc }}</div>
        </div>
    </div>
</template>

<script>
import { hasPermission } from '@/permission/index.js'
export default {
  props: {
    itemData: {
      type: Object,
      default: function () { return {} }
    }
  },
  methods: {
    racingToolClicked (itemData) {
      if (this.hasPerms(itemData.flag)) {
        this.$emit('itemClicked', itemData)
      } else {
        this.$message.warning('暂无操作权限')
      }
    },
    hasPerms: function (perms) {
    // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) // & !this.disabled
    }
  }
}
</script>

<style>
</style>
